import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import './style.scss';
import { Props } from './typing';
import InputField from '../../../../../../components/TextInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ProfileFooter from '../ProfileFooter';
import {
  gstinValidationRegex,
  nameValidationRegex,
} from '../../../../../../lib/constants';
import { decryptUsingAES256, encryptUsingAES256, getMerchantDetailsFromStore } from '../../../../../../lib/helper';
import {
  getSignzyTokenAction,
  getPanToGSTListAction,
  getPanVerifyAction,
  updateAccountAction,
} from '../../../../../../redux/actions/completeProfile';
import Button from '../../../../../../components/Button';
import { PANValidationRegex } from '../../../../../../lib/constants';
import SelectDropdown from '../../../../../../components/Select';
import imgURL from '../../../../../../lib/imgURL';

const MerchantDetails: FC<Props> = (props): JSX.Element => {
  const {
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    updateProfileDetails,
    validationErrors,
    getSignzyTokenAction,
    signzyAuthState,
    getPanToGSTListAction,
    signzyAuthValues,
    getPanVerifyAction,
    panVerifyState,
    loginState,
    updateAccountAction
  } = props;

  const { merchantName, merchantPan, leadId } = getMerchantDetailsFromStore();

  const [signzyAuth, setSignzyAuth] = useState({});
  const [panToGst, setPanToGst]: any = useState([]);
  const [merchantDetails, setMerchantDetails]:any = useState();

  const formik = useFormik({
    initialValues: {
      LegalName: merchantDetails?.LegalName || '',
      GST: merchantDetails?.GST || '',
      pan: merchantDetails?.pan || merchantPan,
    },
    validationSchema: Yup.object({
      LegalName: Yup.string()
        .trim()
        .matches(nameValidationRegex, validationErrors.INVALID_NAME),
      GST: Yup.string()
        .trim()
        .matches(gstinValidationRegex, validationErrors.INVALID_GSTIN),
    }),
    onSubmit: () => {},
  });

  useEffect(() => {
    if (merchantDetails) {
      formik.setValues({
        ...formik.values,
        LegalName: merchantDetails?.LegalName || '',
        GST: merchantDetails?.GST || '',
        pan: merchantDetails?.pan || merchantPan,
      });
    }
  }, [merchantDetails]);

  useEffect(() => {
   if(merchantProfile?.merchantDetails !== ''){
    try {
    setMerchantDetails(JSON.parse(decryptUsingAES256(merchantProfile?.merchantDetails, leadId)));
    } catch(e){
      // Catch Error
    }
   }
  }, [merchantProfile?.merchantDetails]);

  useEffect(() => {
    getSignzyTokenAction();
  }, []);

  useEffect(() => {
    const { isSuccess, isFailure, data } = signzyAuthState;
    if (isSuccess && data) {
      setSignzyAuth({ ...data });
    }

    if (isFailure) {
      setSignzyAuth({});
    }
  }, [signzyAuthState]);

  useEffect(() => {
    const { isSuccess, isFailure, data } = panVerifyState;
    if (isSuccess && data) {
      if (!(data.result.isValid && data.result.panStatus === 'VALID')) {
        formik.setFieldError('pan', 'PAN Number is not valid');
      }

      if (formik.values.LegalName.toLowerCase() !== data.result.name.toLowerCase()) {
        formik.setFieldError(
          'LegalName',
          'PAN Name does not match with Merchant Legal Name'
        );
      }

      if (
        data.result.isValid &&
        data.result.panStatus === 'VALID' &&
        formik.values.LegalName === data.result.name
      ) {
        // notify({
        //   message: 'Success',
        //   type: 'success',
        //   description: 'PAN and Legal Name Verification Successfull',
        // });
        const merchantProfileValue = {
          ...merchantProfile,
          merchantDetails: encryptUsingAES256(JSON.stringify({
            ...formik.values,
            isLegalNameVerified: true,
          }), leadId),
        };
        updateProfileDetails(
          currentStep,
          {
            saved: true,
            completed: false,
          },
          merchantProfileValue
        );
      }
    }
    if (isFailure) {
      formik.setFieldError('pan', 'Error Fetching Pan Details');
    }
  }, [panVerifyState]);

  useEffect(() => {
    const { isSuccess, isFailure, data, errorCode } = signzyAuthValues;
    if (isSuccess && data?.result?.gstinList?.length) {
      formik.setFieldValue('GST', '');
      setPanToGst([
        ...data?.result?.gstinList.reduce((acc, item) => {
          if (item.status === 'ACTIVE') {
            return [...acc, { value: item.gstin, label: item.gstin }];
          }
          return acc;
        }, []),
      ]);
    }

    if (isFailure && errorCode) {
      formik.setFieldError('LegalName', 'Error Fetching GSTIN Details');
      setPanToGst([]);
    }
  }, [signzyAuthValues]);

  useEffect(() => {
    if (!PANValidationRegex.test(formik.values.pan)) {
      setPanToGst([]);
      formik.setFieldValue('GST', '');
    }
  }, [formik.values.pan]);

  const callFormSubmit = (step, statusData) => {
    const merchantProfileValue = {
      ...merchantProfile,
      merchantDetails: encryptUsingAES256(JSON.stringify({
        ...formik.values,
        isLegalNameVerified:
          !!merchantDetails.isLegalNameVerified,
      }), leadId),
    };
    updateProfileDetails(step, statusData, merchantProfileValue);
    if (formik.values.pan !== merchantPan) {
      updateAccountAction({
        merchantId: loginState.MerchantId,
        pan: encryptUsingAES256(formik.values.pan, leadId)
      });
    }
  };

  const callPanToGSTList = () => {
    if (formik.values.LegalName === '') {
      formik.setFieldError(
        'LegalName',
        'Please Enter Valid Legal Name for PAN Verification'
      );
      return false;
    }
    const payload = {
      task: 'panToGstList',
      essentials: { panNumber: formik.values.pan },
    };

    const panVerifyPayload = {
      task: ['1'],
      essentials: { number: formik.values.pan },
    };
    if (!merchantDetails?.isLegalNameVerified) {
      getPanVerifyAction(panVerifyPayload, signzyAuth);
    }

    if (formik.values.GST === '') {
      getPanToGSTListAction(payload, signzyAuth);
    }
    
  };

  const enableSave = () => {
    return formik.values.LegalName !== '' || formik.values.GST !== '';
  };

  const enableSaveAndNext = () => {
    return (
      formik.values.LegalName !== '' &&
      formik.values.GST !== '' &&
      formik.values.pan !== '' &&
      !(formik.errors.LegalName || formik.errors.GST || formik.errors.pan)
    );
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='kyc-merchant-details'>
        <div className='title'>Merchant Details</div>
        {merchantDetails?.isLegalNameVerified && (
            <Row className='success-header'>
              <Col className='ben-name-info' span={13}>
                <div className='bank-verify'>
                  <img width={28} src={imgURL['success-icon']} alt='sucess' />
                  <label className='success-msg'>
                    PAN Details verified Successfully.
                  </label>
                </div>
              </Col>
            </Row>
          )}
        <Row className='plural-merchant-details'>
          <Col span={6}>
            <InputField
              name='MerchantName'
              type='text'
              label='Merchant Name'
              value={merchantName}
              placeholder='Merchant Name'
              className='form-control'
              handleChange={() => {}}
              readonly={true}
            />
          </Col>
          <Col span={6} offset={4}>
            <InputField
              name='LegalName'
              type='text'
              label='Merchant Legal Name'
              isRequired={true}
              value={formik.values.LegalName}
              placeholder='Merchant Legal Name'
              className='form-control'
              onBlur={formik.handleBlur}
              handleChange={formik.handleChange}
              readonly={merchantDetails?.isLegalNameVerified}
              error={Boolean(formik.errors.LegalName)}
              errorMessage={formik.errors.LegalName?.toString()}
            />
          </Col>
        </Row>

        <Row>
          <Col span={6}>
            <div className='form-group'>
              <InputField
                name='pan'
                type='text'
                label='PAN'
                isRequired={true}
                value={formik.values.pan}
                placeholder='PAN'
                className='form-control'
                onBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                readonly={merchantDetails?.isLegalNameVerified}
                error={Boolean(formik.errors.pan)}
                errorMessage={formik.errors.pan?.toString()}
              />
            </div>
          </Col>
          <Col span={3}>
            <label></label>
            <Button
              btnStyleClass='login-primary-button pan-verify'
              onClick={callPanToGSTList}
              label={merchantDetails?.isLegalNameVerified ? 'Get GSTIN' :'Verify'}
              enable={!merchantDetails?.isLegalNameVerified || !PANValidationRegex.test(formik.values.pan)}
              type='button'
            />
          </Col>
          <Col span={6} offset={1}>
            <div className='form-group'>
              <label>
                GSTIN<em>*</em>
              </label>
              <SelectDropdown
                enableSearch={panToGst?.length > 5}
                onChange={(data) => {
                  formik.setFieldValue('GST', data);
                }}
                disabled={panToGst?.length === 0}
                value={formik.values.GST}
                placeholder='Search for GSTIN'
                DropdownIcon={
                  <img src={imgURL['down-arrow']} alt='down-arrow' />
                }
                optionList={panToGst}
                wrapperClass='gstin-dropdown form-control'
                error={Boolean(formik.errors.GST)}
                errorMessage={formik.errors.GST?.toLocaleString()}
              />
            </div>
          </Col>
        </Row>
      </div>
      <ProfileFooter
        nextPage={nextPage}
        prevPage={prevPage}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        saveAction={callFormSubmit}
        enableSave={enableSave()}
        enableSaveAndNext={enableSaveAndNext()}
      />
    </form>
  );
};

const mapStateToProps = ({ validationReducer, completeProfileReducer, loginReducer }) => ({
  validationErrors: validationReducer.validationErrorState.validationErrors,
  signzyAuthState: completeProfileReducer?.signzyAuthState,
  signzyAuthValues: completeProfileReducer?.signzyAuthValues,
  panVerifyState: completeProfileReducer?.panVerifyState,
  loginState: loginReducer?.loginState,
});

export default connect(mapStateToProps, {
  getSignzyTokenAction,
  getPanToGSTListAction,
  getPanVerifyAction,
  updateAccountAction,
})(MerchantDetails);
